module.exports = __webpack_public_path__ + "static/media/logo.d455b2c8.jpeg";